import React, { useContext } from "react";
import "./Works.css";
import html from "../../img/html.png";
import css from "../../img/css.png";
import js from "../../img/js.png";
import mongodb1 from "../../img/mongodb1.png";
import react from "../../img/react.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
            My 
          </span>
          <span>Range of Tech Stack </span>
          <span>
          Knowledge of developing Restful web services with Express and NodeJS.
            <br />
            Deep understanding with advanced Javascript concepts, such as Prototype, Closure and Promise.
            <br />
            Strong knowledge of MongoDB as well as SQL server
            <br />
            Team player with excellent communication, Trouble shooting, Debugging and 
          </span>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Let's Connect</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img style={{height:"130px"}} src={html} alt="" />
          </div>
          <div className="w-secCircle">
            <img style={{height:"130px"}} src={css} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={js} alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img style={{height:"130px"}} src={mongodb1} alt="" />
          </div>
          <div className="w-secCircle">
            <img style={{height:"130px"}} src={react} alt="" />
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
